<template>
  <layout-report :renderBackAndForthFooter="false" :isProgressDone="true" @logoClick="goHome">
    <v-container class="padded">
      <v-row>
        <v-col cols="12" md="8">
          <v-card flat max-width="500">
            <v-card-text>
              <p class="display-1 text--primary">{{ $t(title) }}</p>
              <p v-html="description"></p>
              <login-register-button :large="!isMobile" :small="isMobile" />
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-btn
                    v-if="feedbackCanBeSubmitted && isFeedbackEnabled"
                    :small="isMobile"
                    :large="!isMobile"
                    block
                    :text="!isMobile"
                    :outlined="isMobile"
                    secondary
                    data-test-open-feedback-dialog
                    @click="isFeedbackDialogActive = true"
                  >
                    {{ $t("report.success.giveFeedback") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <confirm-action-dialog
            :isDialogActive.sync="isFeedbackDialogActive"
            :title="$t('report.success.giveFeedbackTitle')"
            :hideLeft="true"
            :hideRight="true"
          >
            <feedback-container :keyForEndpoint="key" @sent="onFeedbackSent"></feedback-container>
          </confirm-action-dialog>
        </v-col>
        <v-col cols="12" md="4">
          <advertisement-card
            v-if="isAdvertisementEnabled"
            :title="$t(adTitle)"
            :subtitle="$t(adSubtitle)"
            :content="$t(adContent)"
            :btnText="$t(adBtnText)"
            imgSrc="https://static.mmmint.ai/wirkaufendeinethg/forest-car-street.jpg"
            logoSrc="https://static.mmmint.ai/wirkaufendeinethg/wirkaufendeinethg_logo.png"
            link="https://www.wirkaufendeinethg.de"
            backgroundColor="#e4f2ee"
            buttonColor="#86c900"
          />
        </v-col>
      </v-row>
    </v-container>
  </layout-report>
</template>

<script lang="ts">
import AdvertisementCard from "@/components/cards/AdvertismentCard.vue";
import FeedbackContainer from "@/components/feedback/FeedbackContainer.vue";
import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { FeedbackTypeEnum } from "@/store/enum/partner/feedback.type.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import { FeatureModule } from "@/store/modules/feature.store";
import LoginRegisterButton from "@/components/utility/LoginRegisterButton.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { PartnerModule } from "@/store/modules/partner";

@Component({
  components: {
    LayoutReport,
    Debug,
    LoginRegisterButton,
    FeedbackContainer,
    ConfirmActionDialog,
    AdvertisementCard
  }
})
export default class ReportSuccess extends Vue {
  isFeedbackDialogActive = false;
  /** If feedback is sent successfully, we should set this to false */
  feedbackCanBeSubmitted = true;

  key = FeedbackTypeEnum.REPORT;

  title = "report.success.title";
  adTitle = "components.cards.AdvertismentCard.wirkaufendeinethg.title";
  adSubtitle = "components.cards.AdvertismentCard.wirkaufendeinethg.subtitle";
  adContent = "components.cards.AdvertismentCard.wirkaufendeinethg.content";
  adBtnText = "components.cards.AdvertismentCard.wirkaufendeinethg.btnText";

  goHome() {
    this.$router.push({ path: "/" });
  }

  get description() {
    return String(
      this.$t("report.success.description", {
        partner: "<a href='" + this.partner?.settings?.websites[0].link + "'>" + this.partner?.companyName + "</a>"
      })
    );
  }

  get partner() {
    return ReportModule.partner;
  }

  get isAdvertisementEnabled() {
    return FeatureModule.isReportAdvertisementEnabled;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get isFeedbackEnabled() {
    return PartnerModule.isRatingSubmissionEnabled;
  }

  onFeedbackSent() {
    this.isFeedbackDialogActive = false;
    this.feedbackCanBeSubmitted = false;
  }
}
</script>

<style scoped>
.contain {
  width: 100%;
  padding: 1em;
}
</style>
